import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFcrfSubgrades = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M3 24a21 21 0 1 0 42 0 21 21 0 1 0-42 0m9.6-12.7h10.357v2.5H15.1v1.868h6.614v2.5H15.1V22.9h-2.5Zm22.8 2.072a5.8 5.8 0 1 0 0 7.456l-1.915-1.607a3.3 3.3 0 1 1 0-4.242ZM12.6 25.1h6.763a3.48 3.48 0 0 1 0 6.96l3.48 4.64h-3l-3.48-4.64H15.1v4.64h-2.5Zm2.5 2.5v1.96h4.263a.98.98 0 0 0 0-1.96Zm9.943-2.5H35.4v2.5h-7.857v1.868h6.614v2.5h-6.614V36.7h-2.5Z"
	})
});
export default SvgFcrfSubgrades;
